export default {
  selectedTab: '1',
  versionProps: {
    title: '滚动表格',
    widgetNum: '2',// 每种组件的唯一编码
    version: '1',  // 每种组件的版本号
    upgrade: true,
    docUrl: '/datavisual/doc/widget'
  },
  viewProps: {
    width: '500',
    height: '400',
    top: 0,
    left: 0,

    dataConfig: {
      header: [],
      data: [],
      index: true,
      columnWidth: [50],
      align: ['center']
    }
  },

  datasourceProps: {
    datasourceType: 'STATIC', // STATIC/API
    dataMapping: [ // table的映射采用数组，其他组件采用json
      {id: 1, prop:'Songj', label: "松江", field: 'Songj'},
      {id: 2, prop:'Pudong', label: "浦东", field: 'Pudong'},
      {id: 3, prop:'JingAn', label: "静安", field: 'JingAn'},
      {id: 4, prop:'Qingpu', label: "青浦", field: 'Qingpu'},
    ],
    dataConfig: {
      'STATIC': {
        data: [
          {id: 1, Pudong:"1-100", Songj:"1-1200", JingAn:"1-180",  Qingpu:"1-809"},
          {id: 2, Pudong:"2-1010", Songj:"2-102", JingAn:"2-180",  Qingpu:"2-890"},
          {id: 3, Pudong:"3-1500", Songj:"3-120", JingAn:"3-1810", Qingpu:"3-819"},
          {id: 4, Pudong:"4-1400", Songj:"4-190", JingAn:"3-1815", Qingpu:"4-1819"},
        ]
      },
      'API': {// API时候的请求参数
        datasource: null,
        datasourceLabel: null,
        reqParams: null,
        data: null,
      },
    }
  }
}
